export default __webpack_public_path__ + "static/installation2-cf7e3a13a0a57c3dbe3dd34f2c4e4a07.gif";